import { render, staticRenderFns } from "./RedirectionLoader.vue?vue&type=template&id=36462e2f&scoped=true&"
import script from "./RedirectionLoader.vue?vue&type=script&lang=js&"
export * from "./RedirectionLoader.vue?vue&type=script&lang=js&"
import style0 from "./RedirectionLoader.vue?vue&type=style&index=0&id=36462e2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36462e2f",
  null
  
)

/* custom blocks */
import block0 from "./RedirectionLoader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VCard,VCardText,VCardTitle,VDivider})
